// extracted by mini-css-extract-plugin
export default {"layout":"index_layout_p7NlT","sharePage":"index_sharePage_Exv7a"};